var config = require('../config.js')
/// CQ 20180531
/// 基础的HTTP请求工具，封装了uni.request
import { attachRequestId, extractRequestId } from '../requestId'
let allRequest = []
let allRequest2 = {}

// 请求统计收集器（用于网络诊断页面）
const MAX_HISTORY = 50
const requestStats = { total: 0, success: 0, failed: 0, history: [] }
function recordRequest(url, success, statusCode) {
  requestStats.total++
  if (success) requestStats.success++
  else requestStats.failed++
  requestStats.history.unshift({ url, success, statusCode, timestamp: Date.now() })
  if (requestStats.history.length > MAX_HISTORY) requestStats.history.pop()
}
export function getRequestStats() {
  const total = requestStats.total
  const success = requestStats.success
  const failed = requestStats.failed
  const successRate = total > 0 ? Math.round((success / total) * 100) : 100
  return { total, success, failed, successRate, history: [...requestStats.history] }
}
export function resetRequestStats() {
  requestStats.total = 0; requestStats.success = 0; requestStats.failed = 0; requestStats.history = []
}
export const abortAllRequest = function () {
  if (allRequest && allRequest.length > 0) {
    for (let i = 0; i < allRequest.length; i++) {
      allRequest[i] && allRequest[i].abort()
    }
    allRequest = []
    allRequest2 ={}
    uni.hideNavigationBarLoading()
  }
}
//监听全局的请求是否完成
export const isAllRequestOver = function(){
  return Object.keys(allRequest2).length===0
}

export const get = function (url, data, header = {}) {
  return new Promise((resolve, reject) => {
    // uni.showNavigationBarLoading()
    const requestId = attachRequestId({ headers: header })
    let requestDate = new Date().getTime()
    var requestTask = uni.request({
      url,
      data,
      header,
      timeout:30000,
      method: 'GET',
      // enableHttpDNS: true, // 开启移动解析
      // httpDNSServiceId: "wxa410372c837a5f26", // 服务市场复制的ID
      complete (resp) {
        const responseRequestId = extractRequestId(resp.header || {}) || requestId
        resp.request_id = responseRequestId
        if (resp.data && typeof resp.data === 'object') {
          resp.data.request_id = resp.data.request_id || responseRequestId
        }

        delete allRequest2[requestDate];
        uni.hideNavigationBarLoading()
        uni.stopPullDownRefresh()
        const isSuccess = resp.statusCode === 200 && resp.data && (resp.data.code === 200 || resp.data.succeeded !== false)
        recordRequest(url, isSuccess, resp.statusCode)
        if (resp.statusCode === 200) {
          if (resp.data.code && resp.data.code !== 200 && !resp.data.succeeded) {
            reject(resp)
          } else {
            resolve(resp)
          }
        } else {
          reject(resp)
        }
      }
    })
    allRequest.push(requestTask)

    allRequest2[requestDate] = requestTask
  })
}

export const post = function (url, data, header = {}) {
  // uni.showNavigationBarLoading()
  const requestId = attachRequestId({ headers: header })
  let requestDate = new Date().getTime()
  return new Promise((resolve, reject) => {
    var requestTask = uni.request({
      url,
      data,
      header,
      timeout:30000,
      method: 'POST',
      // enableHttpDNS: true, // 开启移动解析
      // httpDNSServiceId: "wxa410372c837a5f26", // 服务市场复制的ID
      complete(resp) {
        const responseRequestId = extractRequestId(resp.header || {}) || requestId
        resp.request_id = responseRequestId
        if (resp.data && typeof resp.data === 'object') {
          resp.data.request_id = resp.data.request_id || responseRequestId
        }

        delete allRequest2[requestDate];
        uni.hideNavigationBarLoading()
        uni.stopPullDownRefresh()
        const isSuccess = resp.statusCode === 200 && resp.data && (resp.data.code === 200 || resp.data.succeeded !== false)
        recordRequest(url, isSuccess, resp.statusCode)
        if (resp.statusCode === 200) {
          if (resp.data.code && resp.data.code !== 200 && !resp.data.succeeded) {
            reject(resp)
          } else {
            resolve(resp)
          }
        } else {
          reject(resp)
        }
      }
    })
    allRequest.push(requestTask)

    allRequest2[requestDate] = requestTask
  })
}






